import { render, staticRenderFns } from "./BusinessContact.vue?vue&type=template&id=49f71a16&scoped=true"
import script from "./BusinessContact.vue?vue&type=script&lang=js"
export * from "./BusinessContact.vue?vue&type=script&lang=js"
import style0 from "./BusinessContact.vue?vue&type=style&index=0&id=49f71a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f71a16",
  null
  
)

export default component.exports